import common from "../common";

export default class InsideDoor {

    get back() {
        return this._back;
    }

    get door() {
        return this._openDoor;
    }

    get top() {
        return this._top;
    }

    constructor() {
        this._back = new PIXI.Sprite(P3.assets.texture("doorway_l"));
        this._back.y = -common.STAGE_HEIGHT;

        this._openDoor = new PIXI.Sprite(P3.assets.texture("door_opened"));
        this._openDoor.visible = false;
        this._openDoor.y = -common.STAGE_HEIGHT;

        this._top = new PIXI.Sprite(P3.assets.texture("doorway_r"));
        this._top.y = -common.STAGE_HEIGHT;
    }

    open() {
        this._openDoor.visible = true;
    }

}